export const prepareParams = ({ pageNumber, pageSize, searchKeyword }) => {
  return {
    searchKeyword: searchKeyword ?? "",
    pageNumber: pageNumber,
    pageSize: pageSize,
  };
};
